import {DateTime} from 'luxon';

export const isDateValid = (year: string, month: string, day: string) => {
  if (!day || !month || !year) return false;

  const date = new Date(`${year}-${month}-${day}`);
  const luxDate = DateTime.fromObject({month, day, year});

  return !isNaN(date.getTime()) && luxDate.isValid;
};

export function isUnderAge(birthDateStr, ageLimit) {
  const birthDate = new Date(birthDateStr);
  const today = DateTime.now();
  const birthDateLuxon = DateTime.fromJSDate(birthDate);
  const age = today.diff(birthDateLuxon, 'years').years;

  return Math.floor(age) < ageLimit;
}
